<!-- <div class="row"> -->
   <div class="standard-workspace" style="padding: 20px 10px 10px 10px; width:100%"  [ngStyle]="{'height.px': workspaceHeight}">
      <callsmart-dashboard></callsmart-dashboard>
   </div>
<!-- </div> -->
